import './App.scss';
import 'react-circular-progressbar/dist/styles.css';
import di from './dependency_injection';
import LocalizationProvider, { LocalizationProviderName } from './domain/providers/localization/LocalizationProvider';
import ModalsProvider, { ModalsProviderName } from './domain/providers/modal/ModalsProvider';
import UserProvider, { UserProviderName } from './domain/providers/user/UserProvider';
import RoutesComponent from './presentation/routes/RoutesComponent';
import { CategoryScale } from 'chart.js';
import Chart from 'chart.js/auto';
import MasterDataProvider, { MasterDataProviderName } from './domain/providers/master_data/master_data_provider';
Chart.register(CategoryScale);

const App = () => {
  const localizationProvider = di.get<LocalizationProvider>(LocalizationProviderName);
  const modalsProvider = di.get<ModalsProvider>(ModalsProviderName);
  const userProvider = di.get<UserProvider>(UserProviderName);
  const masterDataProvider = di.get<MasterDataProvider>(MasterDataProviderName);
  return <>
    <localizationProvider.Provider>
      <modalsProvider.Provider>
        <masterDataProvider.Provider>
          <userProvider.Provider>
            <RoutesComponent />
          </userProvider.Provider>
        </masterDataProvider.Provider>
      </modalsProvider.Provider>
    </localizationProvider.Provider>
  </>

}

export default App;
